import { base_colorAlert } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { fontH3 } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  height: fit-content;

  .ExpensePolicyUploadBox-title {
    ${fontH3};
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${spacing(1)};
    flex-wrap: wrap;
  }

  .ExpensePolicyUploadBox-updateBtn {
    transform: scale(0.7);
  }

  .required-asterisk {
    color: ${base_colorAlert};
  }
`
